import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { CustomerInformationInputType } from '../../types/common/CustomerInformationType';
import { SCREEN_NAME } from '../../types/common/CommonType';

import { CustomerInformationBody } from './CustomerInformationBody';
import { addRow as setMoveScreen } from '../../slice/ScreenHistorySlice';
import { useAppSelector, useAppDispatch } from '../../store/hooks';

type CustomerInformationProps = {
    cIInput: CustomerInformationInputType; // 個人情報入力管理
    setCIInput: (value: CustomerInformationInputType) => void; // 個人情報入力管理setState
};

export const CustomerInformation: React.FC<CustomerInformationProps> = ({ cIInput, setCIInput }) => {
    const dispatch = useAppDispatch();
    const navigation = useNavigate();
    // 遷移履歴
    const screenHistory = useAppSelector((s) => s.ScreenHistory);
    // 遷移元情報
    const screenTransition = useAppSelector((s) => s.ScreenTransition);
    // お問い合わせ種別、お問い合わせ理由のマスタ管理
    const masterInquire = useAppSelector((s) => s.MasterInquire);

    // マスタ取得　取得済みであれば実施しない
    useEffect(() => {
        // 入力内容の初期化
        setCIInput({ ...cIInput, pPolicyCheck: false });

        // 遷移直前画面が問合せと問合せ見積入力以外の場合は不正遷移と判断
        if (screenHistory[0] === SCREEN_NAME.CONTACT || screenHistory[0] === SCREEN_NAME.EDIT_ESTIMATION) {
            // 画面遷移ルート追加
            dispatch(setMoveScreen(SCREEN_NAME.CUSTOMER_INFORMATION));
        } else {
            navigation('/');
        }
    }, []);

    return (
        <>
            <CustomerInformationBody
                cIInput={cIInput}
                setCIInput={setCIInput}
                screenTransition={screenTransition}
                masterInquire={masterInquire}
            />
        </>
    );
};
